import { render, staticRenderFns } from "./FanVillage.vue?vue&type=template&id=6231a046"
import script from "./FanVillage.vue?vue&type=script&lang=js"
export * from "./FanVillage.vue?vue&type=script&lang=js"
import style0 from "./FanVillage.vue?vue&type=style&index=0&id=6231a046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports